/**
 * Códigos de erro possíveis para exibição para o usuário conforme documentado em:
 * https://confluence-itau.tecnologia.prod.ops.aws.cloud.ihf/pages/viewpage.action?pageId=640307764
 */
export enum ErrorCodes {
  CANNOT_GET_RELATION_LIST = 'IT-0042',
  NO_RELATION = 'IT-0005',
  NO_CHARON_SESSION = 'IT-0039',
  NO_SPECIFIC_RELATION = 'IT-0040',
  CANNOT_GET_SPECIFIC_RELATION = 'IT-0041'
}
